<template>
  <Container type="card-full">
    <vggrid :list="list" tableheight="600" flexname=""
      :cols="cols" :showfooter="false" :showPage="true"
      :resizable="true" :total="query.total"
      @cellClick="cellClick" @cellDblClick="viewProject" @pagechange="pagechange"
      :isOperate="btn.isOperate" :operateBtn="btn.right" @vggridClick="vggridClick"
    >
        <template slot="btn">
            <menu-btn :menuid="menuid" @btnClick="btnClick" @btnmenuclick="btnmenuclick"></menu-btn>
        </template>
    </vggrid>
  </Container>
</template>
<script>
  import request from  '@/utils/request'
  import MenuBtn from "../common/menuBtn"
  import vggrid from '../common/vggrid'
  import utils from '../../assets/js/utils'
  export default {
    name: 'friendlinkIndex',
    data () {
      return {
        menuid: this.$route.query.menuid,
        list: [],
        btn:{},
        btnLoading: false,
        cols: [
          { field: 'friendlinkseq', fieldtype: 'N', title: '顺序号',calculExpr:'',addNewRowFlg: false, width:80},
          { field: 'friendlinkname', fieldtype: 'C', title: '名称',calculExpr:'',addNewRowFlg: false},
          { field: 'friendlinkurl', fieldtype: 'C', title: 'URL',calculExpr:'',addNewRowFlg: false},
          // { field: 'friendlinkisclose', fieldtype: 'B', title: '关闭',calculExpr:'',addNewRowFlg: false}
        ],
        friendlink: {},
        query: {
          cosid: this.$store.getters.loginUser.cosid,
          total: 0,
          limit: 20,
          offset: 0
        }
      }
    },
    created () {
      this.$on('ADD', () => this.addFriendlink())
      this.$on('CHG', () => this.chgFriendlink())
      this.$on('DEL', () => this.delFriendlink())
      // this.$on('CLOSE', () => this.close())
    },
    activated() {
      this.init()
      this.getPageList()
    },
    mounted () {
    },
    watch: {
    },
    components: {MenuBtn,vggrid},
    methods: {
      btnClick (code) {
        this.$emit(code)
      },
      vggridClick(code,row){
        this.friendlink = row
        this.$emit(code,row)
      },
      btnmenuclick(btn){
        this.btn = btn
      },
      async init() {
        this.query = {
          cosid: this.$store.getters.loginUser.cosid,
          total: 0,
          limit: 20,
          offset: 0}
        this.list = []
        this.btnLoading = false
        this.friendlink = {}
      },
      async close() {
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: ''})
      },
      async addFriendlink () {
        let form = {
          friendlinkid: 0,
          cosid: this.$store.getters.loginUser.cosid
        }
        this.$router.push({name: 'friendlinkForm', params: {form: form, type: 1}})
      },
      async chgFriendlink () {
        if (!this.friendlink.friendlinkid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        this.$router.push({name: 'friendlinkForm', params: {form: this.friendlink, type: 2}})
      },
      async delFriendlink () {
        if (!this.friendlink.friendlinkid) {
          this.$message.warning('请选择一个项目!')
          return
        }
        this.$confirm('确定删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          let data = await request({
            url: '/ywgl/friendlink/delFriendlink',
            method: "post",
            data: this.friendlink
          })
          if (data.issuccess===1) {
            this.getPageList()
            this.$message.success('删除成功！')
          } else {
            this.$message.error(data.msg)
          }
        })
      },
      async cellClick (row) {
        this.friendlink = row.row
      },
      async viewProject(row) {
        this.friendlink = row.row
        this.$router.push({name: 'friendlinkForm', params: {form: this.friendlink,innerbtn: this.btn.inner,type: 3}})
      },
      async pagechange (page) {
        this.query.offset = page.pageSize * (page.currentPage - 1)
        this.query.limit = page.pageSize
        this.getPageList()
      },
      async getPageList () {
        this.loading = true
        let res = await request({
          method: 'get',
          url: '/ywgl/friendlink/getPageList',
          params: this.query
        })
        this.list = res.list
        this.query.total = res.count[0].count
        this.loading = false
      }
    },
    filters: {
    }
  }
</script>
<style lang="scss">

</style>
